import React from 'react';
import {Box} from '@chakra-ui/react';
import HeroSvg from '../../../assets/images/Hero.svg';
import {motion} from 'framer-motion';
import Container from "../../../components/Container";

const PortfolioHero = () => {
    return (
        <>
            <motion.div
                initial={{y: 50, opacity: 0}}
                animate={{y: 0, opacity: 1}}
                transition={{
                    delay: 0.3,
                    default: {duration: 0.5},
                }}
            >
                <Box
                    pt={['49px', '112px']}
                    pb={['39px', '132px']}
                    borderX={'1px'}
                    borderColor={'brandAlpha.200'}
                >
                    <Container>
                        <Box position={'relative'} display={'flex'} justifyContent={'center'}>
                            <img src={HeroSvg} alt="companies-hero"/>
                        </Box>
                    </Container>
                </Box>
            </motion.div>
        </>
    );
};

export default PortfolioHero;
